// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TariffForm_form__y\\+dr8 {
  min-width: 400px;
}
@media (max-width: 550px) {
  .TariffForm_form__y\\+dr8 {
    min-width: auto;
  }
}

.TariffForm_label__u\\+\\+0E {
  color: #242424;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  /* 82.353% */
}

.TariffForm_value__dxG1B {
  color: #242424;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 133.333% */
}

.TariffForm_divider__amIiJ {
  width: 100%;
  height: 1px;
  margin: 0px auto;
  background: #D9D9D9;
}

.TariffForm_row__xse0E {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin: 15px auto;
}

.TariffForm_row2__Mbdbc {
  display: flex;
  height: 25px;
  align-items: center;
  gap: 19px;
  margin-bottom: 15px;
}

.TariffForm_toggle_text__mg7i7 {
  color: #293846;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  /* 100% */
}
.TariffForm_toggle_text__active__3PPzq {
  color: #31C9CA;
}

.TariffForm_title__z\\+bNU {
  color: #242424;
  font-family: Inter;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 28.571px;
  /* 105.82% */
}

.TariffForm_text_small__JlAMR {
  font-size: 16px;
  text-align: center;
  margin-bottom: 1em;
}

.TariffForm_agree__3UQzc, .TariffForm_agree_link__7bbf3 {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  color: #899696;
}
.TariffForm_agree_link__7bbf3 {
  text-decoration: underline;
}

.TariffForm_accent__ZqW\\+s {
  background-color: #fbf4d4;
  border: 2px solid #daa188;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 2em;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Tariffs/TariffForm/TariffForm.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EAHF;IAII,eAAA;EAEF;AACF;;AACA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAAmB,YAAA;AAGrB;;AAAA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAAmB,aAAA;AAIrB;;AADA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAIF;;AADA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAIF;;AADA;EACE,cAAA;EACA,6CAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAAmB,SAAA;AAKrB;AAHE;EACE,cAAA;AAKJ;;AADA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EAAuB,YAAA;AAKzB;;AAFA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;AAKF;;AAFA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAKF;AAHE;EAEE,0BAAA;AAIJ;;AAAA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAGF","sourcesContent":[".form {\n  min-width: 400px;\n\n  @media (max-width: 550px) {\n    min-width: auto;\n  }\n}\n\n.label {\n  color: #242424;\n  font-family: Inter;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px; /* 82.353% */\n}\n\n.value {\n  color: #242424;\n  font-family: Inter;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 133.333% */\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  margin: 0px auto;\n  background: #D9D9D9;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  margin: 15px auto;\n}\n\n.row2 {\n  display: flex;\n  height: 25px;\n  align-items: center;\n  gap: 19px;\n  margin-bottom: 15px;\n}\n\n.toggle_text {\n  color: #293846;\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px; /* 100% */\n\n  &__active {\n    color: #31C9CA;\n  }\n}\n\n.title {\n  color: #242424;\n  font-family: Inter;\n  font-size: 27px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 28.571px; /* 105.82% */\n}\n\n.text_small {\n  font-size: 16px;\n  text-align: center;\n  margin-bottom: 1em;\n}\n\n.agree {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  color: #899696;\n\n  &_link {\n    @extend .agree;\n    text-decoration: underline;\n  }\n}\n\n.accent{\n  background-color: #fbf4d4;\n  border: 2px solid #daa188;\n  border-radius: 10px;\n  padding: 10px;\n  margin-bottom: 2em;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `TariffForm_form__y+dr8`,
	"label": `TariffForm_label__u++0E`,
	"value": `TariffForm_value__dxG1B`,
	"divider": `TariffForm_divider__amIiJ`,
	"row": `TariffForm_row__xse0E`,
	"row2": `TariffForm_row2__Mbdbc`,
	"toggle_text": `TariffForm_toggle_text__mg7i7`,
	"toggle_text__active": `TariffForm_toggle_text__active__3PPzq`,
	"title": `TariffForm_title__z+bNU`,
	"text_small": `TariffForm_text_small__JlAMR`,
	"agree": `TariffForm_agree__3UQzc`,
	"agree_link": `TariffForm_agree_link__7bbf3`,
	"accent": `TariffForm_accent__ZqW+s`
};
export default ___CSS_LOADER_EXPORT___;
